module.exports = __webpack_public_path__ + "static/img/WechatIMG216.6f10c22.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WechatIMG216.jpeg
// module id = u/lt
// module chunks = 0